import { Injectable } from '@angular/core';
import { UserService as BaseUserService } from 'army-builder-shared';

@Injectable({ providedIn: 'root' })
export class FalloutUserService extends BaseUserService {}
